import { QuestionPlanDoNotCountKidsAsStock as Question } from "@/components/features/items/edit/plan/_shared/ui/components/kids-policy/do-not-count-kids-as-stock";

import { useDoNotCountKidsAsStock } from "./hooks/use-do-not-count-kids-as-stock/do-not-count-kids-as-stock";

export const QuestionPlanDoNotCountKidsAsStock = () => {
	const { doNotCountKidsAsStock, onSetDoNotCountKidsAsStock } = useDoNotCountKidsAsStock();

	return (
		<Question
			doNotCountKidsAsStock={doNotCountKidsAsStock}
			onSetDoNotCountKidsAsStock={onSetDoNotCountKidsAsStock}
		/>
	);
};

QuestionPlanDoNotCountKidsAsStock.displayName = "QuestionPlanDoNotCountKidsAsStock";
